import EventBus from "@plugins/common/service/eventbus";

const mediaEventBus = new EventBus();
export default mediaEventBus;
